'use strict'

var $ = require('jquery');
var Debouncer = require('../lib/Debouncer.js');

/**
 * Triggers a function when a given element enters the view
 * @param  {String}   item    The name of the element's class
 * @param  {Function} fn      The function to be triggered
 * @param  {Number}   percentInView How much of the element is in view on trigger. Defaults to 1 (all)
 */
function triggerThis(item, fn, percentInView) {
	var $item = $('.' + item);

	if ($item.length === 0) {
		return;
	}

	var percentInView = (typeof percentInView !== 'undefined') ? percentInView : 1;
	var itemPosition = $item.offset().top
	var itemHeight = $item.outerHeight() * (percentInView);
	var windowHeight = $(window).height();
	var windowScroll = $(window).scrollTop();

	function scrollHandler() {
		windowScroll = $(window).scrollTop();

		if (windowScroll > (itemPosition + itemHeight - windowHeight)) {
			fn();

			$(window).off('scroll.' + item);
		}
	}

	// If item already in view, run function and return.
	if (windowScroll > (itemPosition + itemHeight - windowHeight)) {
		fn();
		return;
	}

	var scrollDebouncer = new Debouncer(scrollHandler);
	$(window).on('scroll.' + item, scrollDebouncer.run);
};


var TriggerOnView = {
	triggerThis: triggerThis
};

module.exports = TriggerOnView;
